<template>
  <section class="section">
    <div class="row">
      <div class="col-md-12 col-xl-12">
        <div class="table-header">
          <h4 class="table-header__title">{{ getTranslation('aboutTesting') }}</h4>
        </div>
      </div>
      <div class="col-md-4  col-xl-4">
        <table class="table-doc">
          <tbody>
          <tr>
            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('totalPoint') }}:</th>
            <td class="table-doc__cell"><p class="text text--bold">{{ testData.totalPoint }} / {{ testData.totalScore }}</p></td>
          </tr>
          <tr>
            <th class="table-doc__cell  table-doc__cell--head">{{ capitalizeFLetter(getTranslation('percentage')) }}:</th>
            <td class="table-doc__cell"><p class="text text--bold" v-html="getPercentageHtml(testInfo.minimalPoint,testData.totalScore,testData.totalPoint)"></p></td>
          </tr>
          <tr>
            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('answers') }}:</th>
            <td class="table-doc__cell"><span class="text--success text--bold">{{ testData.totalTrue }}</span> /
              <span class="text--danger text--bold">{{ testData.totalFalse }}</span>
              <span class="text text--grey"> ( {{ getTranslation('countNotAnswered') }} {{ testData.totalEmpty }} )</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-4  col-xl-4">
        <table class="table-doc">
          <tbody>
          <tr>
            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('startTime') }}:</th>
            <td class="table-doc__cell"><p class="text text--bold">{{ testInfo.startTime }}</p></td>
          </tr>
          <tr>
            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('finishTime') }}:</th>
            <td class="table-doc__cell"><p class="text text--bold">{{ testInfo.endTime }}</p></td>
          </tr>
          <tr>
            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('testStructureDuration') }}:</th>
            <td class="table-doc__cell">
              <p class="text text--bold">{{ testInfo.durationSpent }} / {{ testInfo.duration }} {{ getTranslation('shortMinute') }}</p>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-4  col-xl-4 ">
        <table class="table-doc">
          <tbody>
          <tr>
            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('questionCount') }}:</th>
            <td class="table-doc__cell"><p class="text text--bold">{{ testInfo.questionCount }}</p></td>
          </tr>
          <tr>
            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('minimalPoint') }}:</th>
            <td class="table-doc__cell"><p class="text text--bold">{{ testInfo.minimalScore }} ({{ testInfo.minimalPoint }}%) / {{ testData.totalScore }}</p></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row mt-5">
      <section class="tabs">

        <ul class="nav  tabs__nav  tabs__hor-nav">
          <li class="tabs__nav-item">
            <a class="tabs__nav-link" :class="{'active':tabs.questions}" data-toggle="tab" @click="tabSelect('questions')" :href="'#tab-questions-'+test.test_type_id">{{ getTranslation('questions') }}</a>
          </li>
          <li v-if="hasPermission('api.candidate.test.profile.npaList')" class="tabs__nav-item">
            <a class="tabs__nav-link" :class="{'active':tabs.npa}" data-toggle="tab" @click="tabSelect('npa')" :href="'#tab-npa-'+test.test_type_id">{{ getTranslation('npaList') }}</a>
          </li>
        </ul>


        <div class="tabs__content">

          <div :id="'tab-questions-'+test.test_type_id" class="tabs__pane" :class="{'active':tabs.questions}">
            <div class="col-md-12  col-xl-12">

              <div class="accordion" :id="'accordionExample-'+test.test_type_id">

                <table class="table-3  table-3--full-width">
                  <thead class="table-3__head">
                  <tr class="table-3__row">
                    <th class="table-3__cell  table-3__hcell" style="width: 10%;">№</th>
                    <th class="table-3__cell  table-3__hcell" style="width: 80%;">{{ getTranslation('questions') }} - {{ testData.totalCount }}</th>
                    <th class="table-3__cell  table-3__hcell" style="width: 10%;">
                      {{ getTranslation('answer') }}:
                      <span class="text--success ml-2">{{ testData.totalTrue }}</span> /
                      <span class="text--danger">{{ testData.totalFalse }}</span>
                    </th>
                  </tr>
                  </thead>
                </table>
                <div v-for="question in testData.questions" class="card">
                  <div class="card-header d-flex  align-items-center  flex-wrap" :id="'heading-'+(question.priority+'_'+testInfo.testTypeId)" style="cursor: pointer">
                    <div class="col-1 ml-0 mr-0">
                      <button class="exam__toggle-btn  collapse-btn" :class="{' collapse-btn--active':openId === (question.priority+'_'+testInfo.testTypeId)}">
                        {{ question.priority }}
                        <router-link target="_blank" class="btn  btn--white  btn--square ml-3" :to="{name:'api.question.get',params:{id:question.id},query:{testingId:question.testId}}">
                          <svg class="btn__icon">
                            <use xlink:href="#icon__reload"></use>
                          </svg>
                        </router-link>
                        <span class="collapse-btn__icon-wrap ml-3">
                                    <svg class="collapse-btn__icon" width="15" height="25" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M.297.373C.733-.081 1.49-.127 1.99.27L6 3.46 10.01.27c.498-.397 1.257-.35 1.693.103.437.453.386 1.142-.113 1.539L6.79 5.73c-.452.36-1.128.36-1.58 0L.41 1.912C-.09 1.515-.14.826.297.372z"/>
                                    </svg>
                                </span>
                      </button>
                    </div>
                    <div @click="openQuestion((question.priority+'_'+testInfo.testTypeId))" class="col-9">
                      <button class="btn btn--sm collapsed mb-0 exam__question-text" data-toggle="collapse" :data-target="'#collapse-'+(question.priority+'_'+testInfo.testTypeId)" aria-expanded="true" :aria-controls="'collapse-'+(question.priority+'_'+testInfo.testTypeId)">
                        <MathJaxComponent v-if="question.type==='fill_in'" :formula="question.question"/>
                        <span v-if="question.type!=='fill_in'" v-html="question.question"></span>
                      </button>
                    </div>
                    <div class="col-1 m-0" >
                      {{ question.answerTime }}
                    </div>
                    <div class="col-1 m-0" :class="{'color-danger':!question.status,'color-success':question.status}">
                      <span v-if="question.status"> {{ getTranslation('correct') }}</span>
                      <span v-else>{{ getTranslation('incorrect') }}</span>
                    </div>
                  </div>
                  <div :id="'collapse-'+(question.priority+'_'+testInfo.testTypeId)" class="collapse" :aria-labelledby="'heading-'+(question.priority+'_'+testInfo.testTypeId)" :data-parent="'#accordionExample-'+testInfo.testTypeId">
                    <div class="card-body">
                      <div v-if="question.photoUrl" class="mt-2 col-sm-12 mb-3">
                        <div class="section__header-left mb-2">
                          <h4 class="section__title">
                            {{ getTranslation('questionFigure') }}
                          </h4>
                        </div>
                        <img :src="question.photoUrl" class="question__photo" alt="Фигура вопроса">
                      </div>
                      <div v-if="question.type === 'multiple'">
                        <ul v-if="question.status" class="exam__answers-list">
                          <li v-for="answer in question.answers" :class="{'exam__answer-item':!answer.trueAnswer,'exam__answer-success':answer.trueAnswer}">
                            <label v-if="question.type==='multiple'" class="checkbox" :class="{'checkbox--disabled':!answer.trueAnswer}">
                              <input class="checkbox__input" type="checkbox" disabled :checked="answer.trueAnswer">
                              <span class="checkbox__indicator  checkbox__indicator--lg  checkbox__indicator--inline"></span>
                              <span class="checkbox__label  checkbox__label--lg" v-html="answer.answer">
                                        </span>
                            </label>
                          </li>
                        </ul>
                        <h3 v-if="!question.status && question.candidateAnswers.length < 1" class="title-h3 bg-danger" style="color: white;max-width: 150px; text-align: center">
                          {{ getTranslation('candidateNotAnswered') }}
                        </h3>
                        <ul v-if="!question.status" class="exam__answers-list">

                          <li v-for="answer in question.answers" :class="{'exam__answer-error':question.candidateAnswers.indexOf(answer.id) > -1,'exam__answer-item':!answer.trueAnswer,'exam__answer-success':answer.trueAnswer && question.candidateAnswers.indexOf(answer.id) < 0}"
                              class="exam__answer-item">
                            <label class="checkbox  checkbox--disabled">
                              <input class="checkbox__input" type="checkbox" name="" value="" disabled :checked="question.candidateAnswers.indexOf(answer.id) > -1">
                              <span class="checkbox__indicator  checkbox__indicator--lg  checkbox__indicator--inline"></span>
                              <span class="checkbox__label  checkbox__label--lg" v-html="answer.answer">
                                            </span>
                            </label>
                          </li>

                        </ul>
                      </div>
                      <div v-if="question.type === 'single'">
                        <ul v-if="question.status" class="exam__answers-list">
                          <li v-for="answer in question.answers" :class="{'exam__answer-item':!answer.trueAnswer,'exam__answer-success':answer.trueAnswer}">
                            <label class="radio  radio--inline ">
                              <input class="radio__input" type="radio" :name="'radioBtnSample-'+(question.priority+'_'+testInfo.testTypeId)" :checked="answer.trueAnswer===1" disabled="disabled">
                              <span class="radio__indicator  radio__indicator--lg  radio__indicator--inline"></span>
                              <span class="radio__label  radio__label--lg" v-html="answer.answer">
                                            </span>
                            </label>
                          </li>
                        </ul>
                        <h3 class="title-h3 bg-danger" style="color: white;max-width: 150px; text-align: center" v-if="!question.candidateAnswers">
                          {{ getTranslation('candidateNotAnswered') }}
                        </h3>
                        <ul v-if="!question.status" class="exam__answers-list">
                          <li v-for="answer in question.answers"
                              :class="{'exam__answer-error':question.candidateAnswers && answer.id === question.candidateAnswers.id,'exam__answer-item':!answer.trueAnswer && question.candidateAnswers && answer.id !== question.candidateAnswers.id,'exam__answer-success':answer.trueAnswer}">
                            <label class="radio  radio--inline  radio--disabled">
                              <input class="radio__input" type="radio" :name="'radioBtnSample-'+(question.priority+'_'+testInfo.testTypeId + ((question.candidateAnswers && answer.id === question.candidateAnswers.id) ? ('_'+answer.id) :''))"
                                     :checked="answer.trueAnswer===1 || (question.candidateAnswers && answer.id === question.candidateAnswers.id)" disabled="disabled">
                              <span class="radio__indicator  radio__indicator--lg  radio__indicator--inline"></span>
                              <span class="radio__label  radio__label--lg" v-html="answer.answer">
                                        </span>
                            </label>
                          </li>
                        </ul>
                      </div>
                      <div v-if="question.type === 'fill_in'">
                        <div v-if="question.fillAnswers.length > 0" class="question--fill-in-answers">
                          <table class="table-3 table-borderless">
                            <tbody class="table-3__body">
                            <tr v-for="item in question.fillAnswers" class="table-3__row">
                              <td class="table-3__cell" v-html="item.answer"></td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                        <ul class="exam__answers-list">

                          <li v-if="question.status" class="exam__answer-item">
                            <span class="exam__label">{{ getTranslation('correctAnswer') }}:</span>
                            <span class="exam__field  exam__field--nohover  exam__field--success" v-html="question.answers">
                                        </span>
                          </li>
                          <li v-if="!question.status" class="exam__answer-item">
                            <span class="exam__label">{{ getTranslation('correctAnswer') }}:</span>
                            <span class="exam__field  exam__field--nohover  exam__field--success" v-html="question.answers">
                                        </span>
                          </li>
                          <li v-if="!question.status" class="exam__answer-item">
                            <span class="exam__label" style="width: 219px;">{{ getTranslation('candidateAnswer') }}:</span>
                            <span v-if="question.candidateAnswers" class="exam__field  exam__field--nohover  exam__field--error">
                                        {{ question.candidateAnswers }}
                                    </span>
                            <span v-else class="exam__field  exam__field--nohover  exam__field--error">
                                    </span>
                          </li>

                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>


          <div v-if="hasPermission('api.candidate.test.profile.npaList')" :id="'tab-npa-'+test.test_type_id" class="tabs__pane" :class="{'active':tabs.npa}">
            <table class="table-3 table-borderless">
              <thead class="table-3__head">
              <tr class="table-3__row">
                <td colspan="2" class="table-3__cell  table__hcell">
                  <div class="field-advanced">
                    <form method="post" @submit.prevent="fetchCandidateTestNpa()">
                      <div class="field-advanced__inner">
                        <div class="field-advanced__field-wrap">
                          <input v-model.trim="filterForm.query" class="field  field--full-width  field--bg-grey  js-borderOnFocus" type="text" :placeholder="getTranslation('search')">
                        </div>
                        <div class="field-advanced__right">
                          <button class="btn  btn--square  btn--main">
                            <svg class="btn__icon">
                              <use xlink:href="#icon__search"></use>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </td>
              </tr>
              <tr class="table-3__row">
                <th class="table-3__cell  table__hcell" style="width: 0.5%;">#</th>
                <th class="table-3__cell  table__hcell" style="width: 20%;">{{ getTranslation('namingNPA') }} - {{ npaList.length }}</th>
                <th class="table-3__cell  table__hcell" style="width: 10%;">{{ getTranslation('questionCount') }}</th>
                <th class="table-3__cell  table__hcell" style="width: 10%;">{{ getTranslation('correctsResult') }}</th>
                <th class="table-3__cell  table__hcell" style="width: 10%;">{{ getTranslation('incorrectsResult') }}</th>
                <th class="table-3__cell  table__hcell" style="width: 10%;">{{ getTranslation('points') }}</th>
                <th class="table-3__cell  table__hcell" style="width: 10%;">{{ getTranslation('percentage') }}</th>
              </tr>
              </thead>
              <tbody class="table-3__body">
              <tr class="table-3__row" v-for="item in npaList" v-bind:key="item.id">

                <td class="table-3__cell">
                  {{ item.id }}
                </td>

                <td class="table-3__cell">
                  <router-link :to="{name:'api.testing.get',params:{id:item.id}}">{{ item.title }}</router-link>
                </td>

                <td class="table-3__cell">{{ item.count_total }}</td>

                <td class="table-3__cell">
                  {{ item.count_true }}
                </td>

                <td class="table-3__cell">
                  {{ item.count_total - item.count_true }} /<span class="text text--grey"> {{ item.count_empty }}</span>
                </td>

                <td class="table-3__cell text--bold">
                  {{ Number((parseFloat(item.total_point)).toFixed(2)) }} / {{ Number((parseFloat(item.total_score)).toFixed(2)) }}
                </td>
                <td class="table-3__cell" v-html="getPercentageHtml(testInfo.minimalPoint,item.total_score,item.total_point)">

                </td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>
        <!-- /tabs__content -->

      </section>
    </div>
  </section>
</template>

<script>
import MathJaxComponent from "@/components/MathJaxComponent";
import NpaList from "@/components/shared/NpaList";
import candidateProfileMixin from "../mixins/CandidateProfile";

export default {
  name: "DetailedResultComponent",
  components: {NpaList, MathJaxComponent},
  mixins: [candidateProfileMixin],
  props: {
    active: {
      type: Boolean,
      default: false
    },
    result: {
      type: Object,
      required: true
    },
    test: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      ids: [],
      openId: '',
      tabs: {
        questions: false,
        npa: false
      },
      npaList: [],
      testInfo: {id: null},
      testData: {
        questions: [],
        totalPoint: 0,
        totalScore: 0,
        totalCount: 0,
        totalTrue: 0,
        totalFalse: 0
      },
      filterForm: {},
    }
  },
  watch: {
    'active'(val) {
      if (val)
        this.fetchTestResults().then(() => {
          this.tabSelect('questions');
        });
    },
    'tabs.npa'(val) {
      if (val)
        this.fetchCandidateTestNpa();
    }
  },
  created() {
    if (this.active) {
      this.fetchTestResults()
          .then(() => {
            this.tabSelect('questions');
          });
    }
  },
  methods: {
    fetchCandidateTestNpa() {
      let params = this.cleanObject(this.filterForm);
      return this.axios.get(this.$config.urls.candidate.fetchCandidateTestNpa.url.replace(':id', this.testInfo.id), {params: params})
          .then(response => {
            this.npaList = response.data.data;
          }).catch(() => {
          });
    },
    fetchTestResults() {
      return this.axios.get(this.$config.urls.candidate.fetchTestResults.url.replace(':id', this.result.candidateId), {
        params: {
          resultId: this.result.id,
          testTypeId: this.test.test_type_id
        }
      }).then(response => {
        this.testData = response.data.data.testData;
        this.testInfo = response.data.data.testInfo;
      }).catch(() => {
      });
    },
    openQuestion(id) {
      if (this.openId === id)
        this.openId = '';
      else
        this.openId = id;
    },
    openCollapse(id) {
      let idIndex = this.ids.indexOf(id);
      if (idIndex < 0)
        this.ids.push(id);
      else {
        this.ids.splice(idIndex, 1);
      }
    }
  },

}
</script>

<style scoped>
.exam__question-text {
  max-width: 1220px;
  margin-bottom: 40px;
  color: #0d3272 !important;
  font-size: 16px;
  line-height: 24px;
  font-style: normal;
  font-weight: 700;
}

.tabs__pane {
  padding: 13px 0 !important;
}

.btn {
  position: relative;
  display: -ms-inline-flexbox;
  display: -webkit-inline-box;
  display: inline-flex;
  -ms-flex-align: start !important;
  -webkit-box-align: start !important;
  align-items: flex-start !important;
  -ms-flex-pack: start !important;
  -webkit-box-pack: start !important;
  justify-content: start !important;
  margin-bottom: 0 !important;
  margin-right: 0 !important;
  padding: 5px !important;
  font-size: 15px;
  font-weight: bold;
  line-height: 1.1em !important;
  text-align: left !important;
  text-decoration: none;
  vertical-align: middle;
  border: 1px solid transparent;
  border-radius: 4px;
  outline: 1px solid transparent;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  overflow: hidden;
  -webkit-transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.exam__answer-success {
  margin-bottom: 15px;
}

.exam__answer-error {
  margin-bottom: 15px;
}
</style>
